export default "__VITE_ASSET__BgSGIqed__"